import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Payslip } from "@/v2/types";

export default async function CreatePayslip(data: any): Promise<Payslip> {
    const res = await apiClientWithRefreshToken({
        url: "/payslips",
        method: "POST",
        data: data,
    });

    return res.data;
}
